import React, { useContext } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";

import axios from "axios";
import ThanksPage from "./pages/thanks/ThanksPage";
import Activations from "./pages/Home/Activations";
import WinnerPicker from "./pages/selectWinners/WinnerPicker";
import Footer from "./components/footer/Footer";
import Login from "./pages/admin/Login";
import { ProtectedRoute } from "./util/ProtectedRoute";
import Layout from "./components/layout/Layout";
import Dashboard from "./pages/admin/Dashboard";
import Event from "./pages/admin/Event";
import EventData from "./pages/admin/EventData";
import { AuthContext } from "./context/AuthContext";

//axios.defaults.baseURL = "http://localhost:6029/api/v1";
axios.defaults.baseURL = "https://api.chocodate.ae/api/v1";
axios.defaults.withCredentials = true;

const App = () => {

    const { admin } = useContext(AuthContext);
  
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/" element={<Home />} /> */}
        <Route path="/thank-you" element={<ThanksPage />} />
        <Route path="/" element={<Activations />} />
        <Route path="/login" element={<Login />} />
        <Route path="/select-winner/:eventName" element={<WinnerPicker />} />
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/event" element={<Event />} />
          <Route path="/event-data/:eventName" element={<EventData />} />
        </Route>
      </Routes>

      <Footer />
    </BrowserRouter>
  );
};

export default App;
